import { render, staticRenderFns } from "./BankVaultActionView.vue?vue&type=template&id=cb55ffb6&"
import script from "./BankVaultActionView.vue?vue&type=script&lang=js&"
export * from "./BankVaultActionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports